import { normalizeMcpClient } from './mcp_client.js';

const STORAGE_KEY = 'measureStudioMcpOnboardingStartedAt';
const INTENT_LIFETIME_MS = 30 * 24 * 60 * 60 * 1000;

const browserStorage = () => {
  if (typeof window === 'undefined') return null;

  try {
    return window.localStorage;
  } catch (_error) {
    return null;
  }
};

export const rememberMcpOnboarding = (client, storage = browserStorage(), startedAt = Date.now()) => {
  try {
    storage?.setItem(STORAGE_KEY, JSON.stringify({
      client: normalizeMcpClient(client),
      startedAt,
    }));
  } catch (_error) {}
};

export const clearMcpOnboarding = (storage = browserStorage()) => {
  try {
    storage?.removeItem(STORAGE_KEY);
  } catch (_error) {}
};

export const getMcpOnboarding = (storage = browserStorage(), now = Date.now()) => {
  try {
    const raw = storage?.getItem(STORAGE_KEY);
    const stored = JSON.parse(raw);
    const legacyStartedAt = Number(stored);
    const startedAt = stored?.startedAt || legacyStartedAt;
    const active = startedAt > 0 && now - startedAt <= INTENT_LIFETIME_MS;

    if (!active) clearMcpOnboarding(storage);

    if (!active) return null;

    return {
      client: stored?.client ? normalizeMcpClient(stored.client) : 'claude',
      startedAt,
    };
  } catch (_error) {
    clearMcpOnboarding(storage);
    return null;
  }
};

export const isMcpOnboardingActive = (storage = browserStorage(), now = Date.now()) => (
  !!getMcpOnboarding(storage, now)
);
